import { useState  } from 'react';

export default function ContactSection() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitting(true);
    setFormError('');

    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('phone_alt');
    if (honeypot && typeof honeypot === 'string' && honeypot.trim() !== '') {
      setFormStatus('success');
      setSubmitting(false);
      return;
    }

    formData.delete('phone_alt');

    try {
      const res = await fetch('https://readdy.ai/api/form/d9sola94ne17ei0sdl5g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await res.text();
      let parsed: Record<string, unknown> = {};
      try {
        parsed = JSON.parse(responseText);
      } catch {
        // not JSON
      }

      const serverMsg =
        (parsed?.meta as Record<string, string>)?.message ||
        (parsed?.message as string) ||
        responseText ||
        '';

      if (
        res.ok &&
        parsed?.code === 'OK'
      ) {
        setFormStatus('success');
        form.reset();
      } else if (
        serverMsg.includes('spam') ||
        serverMsg.includes('form data is spam')
      ) {
        setFormError(serverMsg || '提交失败，请稍后再试');
        setFormStatus('error');
      } else {
        setFormError(serverMsg || '提交失败，请检查信息后重试');
        setFormStatus('error');
      }
    } catch {
      setFormError('网络错误，请检查网络后重试');
      setFormStatus('error');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section id="contact">
      <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading mb-8 text-center">
        联系我们
      </h2>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div>
          <p className="text-sm text-foreground-300 leading-relaxed mb-6">
            如果您有任何问题、建议或合作意向，欢迎通过以下方式联系我们，或者填写右侧表单，我们会在24小时内回复您。
          </p>
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10 flex-shrink-0">
                <i className="ri-mail-line text-primary-400"></i>
              </div>
              <div>
                <div className="text-xs text-foreground-500">邮箱</div>
                <div className="text-sm text-foreground-200">service@nencaoyingyuan.com</div>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100/20 flex-shrink-0">
                <i className="ri-phone-line text-secondary-400"></i>
              </div>
              <div>
                <div className="text-xs text-foreground-500">客服电话（工作时间：9:00-18:00）</div>
                <div className="text-sm text-foreground-200">400-888-9999</div>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100/20 flex-shrink-0">
                <i className="ri-map-pin-line text-accent-400"></i>
              </div>
              <div>
                <div className="text-xs text-foreground-500">公司地址</div>
                <div className="text-sm text-foreground-200">北京市朝阳区望京科技园A座12层</div>
              </div>
            </div>
          </div>
        </div>

        <form
          data-readdy-form
          onSubmit={handleSubmit}
          className="space-y-4"
        >
          <div>
            <label htmlFor="contact-name" className="block text-sm text-foreground-300 mb-1.5">
              您的姓名 <span className="text-accent-400">*</span>
            </label>
            <input
              id="contact-name"
              name="name"
              type="text"
              required
              className="w-full px-4 py-2.5 rounded-lg bg-background-200/40 border border-background-200/40 focus:border-primary-500/50 focus:outline-none text-sm text-foreground-100 placeholder:text-foreground-600 transition-all"
              placeholder="请输入您的姓名"
            />
          </div>

          <div>
            <label htmlFor="contact-email" className="block text-sm text-foreground-300 mb-1.5">
              电子邮箱 <span className="text-accent-400">*</span>
            </label>
            <input
              id="contact-email"
              name="email"
              type="email"
              required
              className="w-full px-4 py-2.5 rounded-lg bg-background-200/40 border border-background-200/40 focus:border-primary-500/50 focus:outline-none text-sm text-foreground-100 placeholder:text-foreground-600 transition-all"
              placeholder="请输入您的邮箱"
            />
          </div>

          <div>
            <label htmlFor="contact-subject" className="block text-sm text-foreground-300 mb-1.5">
              主题
            </label>
            <input
              id="contact-subject"
              name="subject"
              type="text"
              className="w-full px-4 py-2.5 rounded-lg bg-background-200/40 border border-background-200/40 focus:border-primary-500/50 focus:outline-none text-sm text-foreground-100 placeholder:text-foreground-600 transition-all"
              placeholder="请输入主题"
            />
          </div>

          <div>
            <label htmlFor="contact-message" className="block text-sm text-foreground-300 mb-1.5">
              留言内容 <span className="text-accent-400">*</span>
            </label>
            <textarea
              id="contact-message"
              name="message"
              required
              maxLength={500}
              rows={4}
              className="w-full px-4 py-2.5 rounded-lg bg-background-200/40 border border-background-200/40 focus:border-primary-500/50 focus:outline-none text-sm text-foreground-100 placeholder:text-foreground-600 transition-all resize-none"
              placeholder="请输入您的留言内容（500字以内）"
            />
          </div>

          <div className="website-alt-field">
            <label htmlFor="phone-alt">Phone</label>
            <input
              id="phone-alt"
              name="phone_alt"
              type="text"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
            />
          </div>

          <button
            type="submit"
            disabled={submitting}
            className="w-full py-3 rounded-lg bg-primary-500 hover:bg-primary-600 text-background-950 font-semibold text-sm transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
          >
            {submitting ? '提交中...' : '发送留言'}
          </button>

          {formStatus === 'success' && (
            <div className="p-3 rounded-lg bg-secondary-100/10 border border-secondary-400/30 text-sm text-secondary-300 text-center">
              感谢您的留言！我们会尽快回复您。
            </div>
          )}
          {formStatus === 'error' && formError && (
            <div className="p-3 rounded-lg bg-accent-100/10 border border-accent-400/30 text-sm text-accent-300 text-center">
              {formError}
            </div>
          )}
        </form>
      </div>
    </section>
  );
}